module.exports = __webpack_public_path__ + "static/media/it.b3bd09cf.svg";